<template>
  <div id="login" :class="{ 'dialog-status': isDialog }">
    <div id="login-box" class="login-box">
      <div
        class="login_close iconfont icon-close"
        v-if="isDialog"
        @click="loginClose"
      ></div>
      <div class="login-content">
        <div class="login-header" v-if="passLoginStatus">
          <img src="@/assets/image/logo@2x.png" width="150" height="30" />
        </div>
        <!-- <h1>{{ loginTitle }}</h1> -->
        <!-- 微信登录 -->
        <template v-if="wayType == 'wechat'">
          <wechat-login :isDialog="isDialog" />
        </template>
        <template v-if="wayType == 'mobile'">
          <password-login :isDialog="isDialog" />
        </template>
        <!--验证码登录-->
        <template v-if="wayType == 'sms'">
          <sms-code-login :isDialog="isDialog" />
        </template>
        <!--重置密码-->
        <template v-if="wayType == 'find'">
          <reset-password
            :type="7"
            :sign="sign"
            @goBack="goBack"
            :isDialog="isDialog"
          />
        </template>

        <div class="help-btn" v-if="wayType == 'mobile' || wayType == 'sms'">
          <div @click="passwordLogin" class="checkLogin">
            {{ wayType == "mobile" ? "验证码登录" : "密码登录" }}
          </div>
          <div @click="resetPassword" v-if="wayType == 'mobile'">忘记密码?</div>
        </div>
      </div>

      <div class="other"><span>其它</span></div>
      <div class="login-way">
        <div
          class="login-way-item"
          v-if="wayType == 'wechat'"
          @click="wayType = 'mobile'"
        >
          <div class="login-way-icon phone"></div>
          <div class="login-way-font">账号登录</div>
        </div>
        <div
          class="login-way-item"
          v-if="wayType == 'mobile' || wayType == 'sms'"
          @click="changtype('wechat')"
        >
          <div class="login-way-icon wechat"></div>
          <div class="login-way-font">微信登录</div>
        </div>
        <div class="login-way-item" @click="getQQLogin">
          <div class="login-way-icon qq"></div>
          <div class="login-way-font">QQ登录</div>
        </div>
        <div class="login-way-item" @click="getWeiboLogin">
          <div class="login-way-icon weibo"></div>
          <div class="login-way-font">微博登录</div>
        </div>
        <div class="login-way-item" @click="getQiyeLogin">
          <div class="login-way-icon qywechat"></div>
          <div class="login-way-font">企业微信</div>
        </div>
      </div>
      <div class="login-footer">
        <p class="agreement">
          登录即同意<span @click="handleAgreement('user')">用户使用协议</span
          >和<span @click="handleAgreement('auth')">授权许可协议</span>
        </p>
        <p class="service">
          如有问题请<span @click="handleService">联系客服</span>
        </p>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      custom-class="login_dialog"
      :center="true"
    >
      <span class="login_dialog_content"
        >您尚未添加企业微信应用，请先联系企业微信管理员添加</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="扫码添加客服"
      :visible.sync="serviceVisible"
      custom-class="service_dialog"
      :center="true"
      :footer="null"
      :modal="false"
      :close-on-click-modal="false"
    >
      <div class="service_dialog_img">
        <img src="@/assets/image/wxcode.jpg" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wechatLogin from "../Login/wechatLogin";
import passwordLogin from "../Login/passwordLogin.vue";
import ResetPassword from "../Login/resetPassword1.vue";
import SmsCodeLogin from "../Login/smsCodeLogin.vue";
import tokenFunc from "@/config/static/token";
export default {
  components: { passwordLogin, SmsCodeLogin, ResetPassword, wechatLogin },
  name: "Login",
  data() {
    return {
      type: "password",
      passLoginStatus: true,
      loginT: {
        type: 1,
        title: "验证码登录",
      },
      getWeixinLogin: null, // 后期微信用于登录  在关闭或者切换登录 需要设置为null 防止内存泄露
      exprieStatus: false, // 过期后显示过期图片
      wechatForm: {},
      loginType: 1,
      loginTitle: "验证码登录",
      loginParams: {
        // 后期用于统计注册操作 来源主要通过url
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
      },
      dialogVisible: false,
      serviceVisible: false, // 扫码联系客服弹窗
      sign: "", // 微信轮询接口返回
      showIframe: false,
      wayType: "mobile",
    };
  },
  computed: {
    isDialog() {
      return this.$route.query.type === "dialog";
    },
    loginTitle() {
      let str = "";
      switch (this.wayType) {
        case "wechat":
          str = "微信扫一扫登录";
          break;
        case "mobile":
          str = "手机号登录";
          break;
        case "sms":
          str = "短信验证码登录";
          break;
        case "account":
          str = "账号密码登录";
          break;
        default:
          break;
      }
      return str;
    },
  },
  created() {
    if (this.$route.query.type == "logout") {
    //   localStorage.removeItem("authorization");
    }
    let { utm_source, utm_medium, utm_campaign } = this.$route.query;
    this.loginParams = {
      utm_source: utm_source || "",
      utm_medium: utm_medium || "",
      utm_campaign: utm_campaign || "",
    };
    this.showIframe = true;
  },
  mounted() {
    if (tokenFunc.getToken()) {
      this.$router.push({ name: "Team", query: this.$route.query });
    }
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.getWeixinLogin);
      this.getWeixinLogin = null;
    });
  },
  methods: {
    changtype(data) {
      this.wayType = data;
    },
    passwordLogin() {
      if (this.wayType == "mobile") {
        this.wayType = "sms";
      } else {
        this.wayType = "mobile";
      }

      // this.passLoginStatus = !this.passLoginStatus;
    },
    resetPassword() {
      this.wayType = "find";
      this.loginTitle = "设置新密码";
    },
    goBack() {
      this.wayType = "mobile";
      this.passLoginStatus = true;
      clearInterval(this.getWeixinLogin);
    },
    renovateWechat() {
      this.exprieStatus = false;
      this.getWechatCode();
    },
    loginClose() {
      window.parent.postMessage({ type: "close", val: 1 }, "*");
    },
    getWechatCode() {
      let loginParams = { register_type: 1 };
      loginSdk.requestAction("wechat_code", loginParams).then((res) => {
        if (res.code == 0) {
          this.afterLoginOperate(res.data);
        }
      });
    },

    handleAgreement(type) {
      let straight_id = type === "user" ? "yhxy" : "sqxk";
      window.open(
        `https://www.isheji.com/helpercenter?straight_id=${straight_id}`,
        "_blank"
      );
    },
    handleService() {
      this.serviceVisible = true;
    },
    getQQLogin() {
      let that = this;
      var loginParams = {
        register_type: 2,
        referer: `${loginSdk.baseOptions.baseUri}${loginSdk.baseOptions.qqRedirectRoute}`,
      };
      //合并utmParams
      var utmParams = localStorage.utmParams
        ? JSON.parse(localStorage.utmParams)
        : {};
      loginParams = Object.assign(loginParams, utmParams);
      loginSdk
        .requestAction("qq_direct_auth", loginParams)
        .then((res) => {
          loginSdk
            .launchAuthorizationFlow({
              type: "qq",
              redirectURI: res.data,
            })
            .then((data) => {
              this.$message.success("登录成功");
              if (data.data && data.data.code == 0) {
                that.afterLoginOperate(data.data);
              }
            })
            .catch((error) => {
              that.catchMessage(error);
            });
        })
        .catch((error) => {
          that.catchMessage(error);
        });
    },
    getWeiboLogin() {
      let that = this;
      var loginParams = {
        register_type: 2,
        referer: `${loginSdk.baseOptions.baseUri}${loginSdk.baseOptions.weiboRedirectRoute}`,
      };
      //合并utmParams
      var utmParams = localStorage.utmParams
        ? JSON.parse(localStorage.utmParams)
        : {};
      loginParams = Object.assign(loginParams, utmParams);

      loginSdk
        .requestAction("weibo_direct_auth", loginParams)
        .then((res) => {
          if (res.code == 0) {
            loginSdk
              .launchAuthorizationFlow({
                type: "weibo",
                redirectURI: res.data,
              })
              .then((data) => {
                if (data.data && data.data.code == 0) {
                  that.afterLoginOperate(data.data);
                }
              })
              .catch((error) => {
                that.catchMessage(error);
              });
          }
        })
        .catch((err) => {
          //报错
          that.catchMessage(err);
        });
    },
    getQiyeLogin() {
      let that = this;
      var loginParams = {
        register_type: 2,
        referer: `${loginSdk.baseOptions.baseUri}${loginSdk.baseOptions.qywxRedirectRoute}`,
      };
      //合并utmParams
      var utmParams = localStorage.utmParams
        ? JSON.parse(localStorage.utmParams)
        : {};
      loginParams = Object.assign(loginParams, utmParams);

      loginSdk
        .requestAction("wecom_direct_auth", loginParams)
        .then((res) => {
          if (res.code == 0) {
            loginSdk
              .launchAuthorizationFlow({
                type: "wecom",
                redirectURI: res.data,
              })
              .then((data) => {
                if (data.data && data.data.code == 0) {
                  that.afterLoginOperate(data.data);
                }
              })
              .catch((error) => {
                that.catchMessage(error);
              });
          }
        })
        .catch((err) => {
          //报错
          that.catchMessage(err);
        });
    },
    getBaiduLogin() {
      let that = this;
      var loginParams = {
        register_type: 1,
        referer: `${loginSdk.baseOptions.baseUri}${loginSdk.baseOptions.qywxRedirectRoute}`,
      };
      //合并utmParams
      var utmParams = loginSdk.utmParams;
      loginParams = Object.assign(loginParams, utmParams);
      loginSdk
        .requestAction("wecom_direct_auth", loginParams)
        .then((res) => {
          if (res.code == 0) {
            localStorage.setItem(
              "trackLoginData",
              JSON.stringify({
                login_type: "wechat",
                source: that.pageLoginSuccessInfo.position,
              })
            );
            loginSdk
              .launchAuthorizationFlow({
                type: "wecom",
                redirectURI: res.data,
              })
              .then((data) => {})
              .catch((error) => {
                that.catchMessage(error);
              });
          }
        })
        .catch((err) => {
          //报错
          that.catchMessage(err);
        });
    },
    afterLoginOperate (data) {
      tokenFunc.setToken(data.token)
      this.$store.dispatch("loginInfo").then((res) => {
        if (this.isDialog) {
          window.parent.postMessage({ type: "isLogin", val: data.token }, "*");
          return;
        }

        // 编辑器页面登录跳回处理 koko
        // const { search } = window.location
        // const newUrl = decodeURIComponent(search).substring(6)
        // if(newUrl && newUrl === 'enterprise-design-v1') {
        //     window.location.href = localStorage.getItem("enterprise-design-v1-url");
        //     return;
        // }

        if (res) {
          let domain = res.current_team_domain;
          if (process.env.VUE_APP_RealmName && domain) {
            // 配置域名
            domain = domain.split(".")[0] + `.${process.env.VUE_APP_RealmName}`;
          }
          if (domain) {
            window.location.href = `https://${domain}`;
          } else {
            this.$router.push({ name: "Team", query: this.$route.query });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
#login {
  @include wh(100vw, 100vh);
  background: url("../../../../assets/image/login-bg.jpg") no-repeat;
  // background-size: 100% 100%;
  background-position: center center;

  &.dialog-status {
    background: rgba(0, 0, 0, 0.5);
  }
  .login-box {
    width: 400px;
    background: #ffffff;
    border-radius: 8px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-top: 42px;
    position: relative;
    .login_close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .login-header {
      @include wh(100%, 33px);
      display: flex;
      font-size: 24px;
      justify-content: center;
      align-items: center;
      margin-bottom: 37px;
      .header-text {
        margin-left: 4px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 33px;
      }
    }
    h3 {
      @include wh(100%, 28px);
      font-size: 24px;
      font-weight: 500;
      color: #3c3c43;
      line-height: 28px;
      text-align: center;
      margin-bottom: 42px;
    }
    .login-content {
      min-height: 100px;
    }
    .sms-login {
      @include wh(100%, 33px);
      font-size: 24px;
      color: #3c3c43;
      margin-bottom: 32px;
    }
    .login-form {
      padding: 0 50px;
      .login-input {
        flex: 1;
        height: 42px;
      }
      .login-btn {
        @include wh(90px, 42px);
        border-radius: 4px;
        // border: none;
        cursor: pointer;
        color: #9e9da7;
        border: 1px solid #e1e1e1;
        padding: 0;
        margin-left: 8px;
        font-size: 14px;
        &.getcode-btn {
          background: #f7f6f9;
          font-size: 14px;
          span {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3b3946;
            line-height: 20px;
          }
        }
        span {
          width: 100%;
          display: block;
        }
      }
      #phone {
        width: 110px;
        &.pass-input {
          width: 300px;
        }
      }
      #code {
        width: 102px;
        &.pass-input {
          width: 300px;
        }
      }
    }
    .pic-con {
      @include wh(300px, 40px);
      border-bottom: 1px solid #dedede;
      margin-top: 22px;
      img {
        @include wh(99px, 39px);
        background: #ffffff;
        border-radius: 0px 4px 4px 0px;
      }
      #pic-code {
        width: 200px;
        border: none;
        float: left;
      }
    }
    .submit-item {
      margin-top: 42px;
      .submit-btn {
        @include wh(300px, 42px);
        // background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
        // border-radius: 8px;
        text-align: center;
        line-height: 42px;
        // color: #fff;
        cursor: pointer;
        padding: 0;
        // border: none;
        font-size: 13px;
      }
    }
    .help-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;
      padding: 0 50px;
      div {
        // width: 56px;
        height: 20px;
        font-size: 14px;
        color: #6e6c76;
        line-height: 20px;
        cursor: pointer;
      }
      .checkLogin {
        color: #5a2df5;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .other {
      width: calc(100% - 100px);
      height: 17px;
      color: #c9c7d2;
      margin: 0 auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      span {
        width: 44px;
        height: 100%;
        background-color: #fff;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        z-index: 9;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #c9c7d2;
        left: 0;
        top: 8px;
      }
    }
    .login-way {
      /* position: absolute;
        left: 50%;
        bottom: 100px;
        transform: translateX(-50%); */
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 37px auto 63px;
      .login-way-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 40px;
        height: 40px;
        margin-right: 30px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        .login-way-icon {
          width: 100%;
          height: 100%;
          &.phone {
            background: url("../../../../assets/image/logindialog/phone.png");
            background-size: 100%;
            &.active,
            &:hover {
              background: url("../../../../assets/image/logindialog/phoneh.png");
              background-size: 100%;
            }
          }
          &.wechat {
            background: url("../../../../assets/image/logindialog/weixin.png");
            background-size: 100%;
            &.active,
            &:hover {
              background: url("../../../../assets/image/logindialog/weixinh.png");
              background-size: 100%;
            }
          }
          &.qq {
            background: url("../../../../assets/image/logindialog/qq.png");
            background-size: 100%;
            &.active,
            &:hover {
              background: url("../../../../assets/image/logindialog/qqh.png");
              background-size: 100%;
            }
          }
          &.weibo {
            background: url("../../../../assets/image/logindialog/weibo.png");
            background-size: 100%;
            &.active,
            &:hover {
              background: url("../../../../assets/image/logindialog/weiboh.png");
              background-size: 100%;
            }
          }
          &.qywechat {
            background: url("../../../../assets/image/logindialog/qyweChat.png");
            background-size: 100%;
            &.active,
            &:hover {
              background: url("../../../../assets/image/logindialog/qyweChath.png");
              background-size: 100%;
            }
          }
        }
        .login-way-font {
          position: absolute;
          bottom: -23px;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3b3946;
          line-height: 17px;
        }
      }
    }
    .other-login {
      margin-top: 16px;
      div {
        width: calc(100% - 100px);
        height: 42px;
        margin: 0 auto;
        border: 1px solid #5a2df5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #5a2df5;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        span {
          margin-left: 6px;
        }
      }
      .wx-login {
        margin-bottom: 16px;
      }
      .qw-login {
        margin-bottom: 24px;
      }
    }
    .login-footer {
      width: 100%;
      height: 80px;
      background-color: #f7f6f9;
      text-align: center;
      padding: 16px 0;
      color: #6e6c76;
      font-size: 14px;
      span {
        user-select: none;
        cursor: pointer;
      }
      .agreement {
        span {
          text-decoration: underline;
          text-decoration-color: #6e6c76;
          margin: 0 3px;
        }
      }
      .service {
        margin-top: 8px;
        span {
          color: #5a2df5;
        }
      }
    }
  }
}
.wechat-image {
  @include wh(240px, 240px);
  // padding: 14px;
  margin: 0 auto 34px;
  background-color: #f7f6f9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .warning_mask {
    @include wh(100%, 100%);
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #e7e7e6;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    img {
      @include wh(36px, 36px);
      display: block;
      margin: 50px auto 10px;
    }
    p {
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #000;
      line-height: 20px;
    }
    a {
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #7966ff;
      line-height: 20px;
      cursor: pointer;
    }
  }
}
.service_dialog {
  @include wh(230px, 260px);
  border-radius: unset;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  .el-dialog__header {
    padding: 16px;
    text-align: left;
    border-bottom: 2px solid #f7f6f9;
    color: #3b3946;
  }
  .el-dialog__body {
    padding: 0;
  }
  .service_dialog_img {
    @include wh(180px, 180px);
    margin: 13px 25px;
    background-color: #f7f6f9;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      @include wh(172px, 172px);
    }
  }
}
#qw-dialog-iframe {
  position: fixed;
  top: 0;
}
</style>

<style lang="scss">
.login-form {
  .el-input__inner {
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 24px;
  }
  .codeImg {
    img {
      width: 90px;
      height: 42px;
      cursor: pointer;
      border: 1px solid #e1e1e1;
      margin-left: 8px;
      border-radius: 4px;
      box-sizing: border-box;
    }
  }
}
.mobile-form {
  .el-form-item__content {
    display: flex;
  }
}
.login_dialog {
  .el-dialog__body {
    padding: 30px 50px;
    font-size: 16px;
    color: #2d2d32;
  }
  .el-dialog__footer {
    font-size: 16px;
  }
}

</style>
